import React from 'react';
import { PropTypes } from 'prop-types';
import { useScreenSmDown, useScreenMinMd } from '@hooks/useResponsive';

const getIconDesktop = isActive => {
    const fill = isActive ? '#246EFF' : '#D3D0D5';
    const stroke = isActive ? '#fff' : '#000';
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="19.6923" cy="19.7499" r="19.6923" fill={fill} />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 11.0576L12 17.1529V27.0576H17.6V21.7243H22.4V27.0576H28V17.1529L20 11.0576Z"
                stroke={stroke}
                strokeLinecap="square"
            />
        </svg>
    );
};

const getIconMobile = isActive => {
    const stroke = isActive ? '#246EFF' : '#1A1A1A';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
            <polygon
                fill="none"
                stroke={stroke}
                strokeLinecap="square"
                points="5.302 0 0 4.241 0 11.134 3.711 11.134 3.711 7.422 6.892 7.422 6.892 11.134 10.604 11.134 10.604 4.241"
                transform="translate(1 1)"
            />
        </svg>
    );
};

const MenuDashboard = ({ isActive = false }) => {
    const isScreenSmDown = useScreenSmDown();
    const isScreenMinMd = useScreenMinMd();

    return (
        <>
            {isScreenSmDown && getIconMobile(isActive)}
            {isScreenMinMd && getIconDesktop(isActive)}
        </>
    );
};

MenuDashboard.propTypes = {
    isActive: PropTypes.bool,
};

export default MenuDashboard;
